export function normalizeAppSlugInput(value: string): string {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+/, '')
    .slice(0, 50)
}

export function finalizeAppSlug(value: string): string {
  return normalizeAppSlugInput(value).replace(/-+$/, '')
}

export function appSlugFromName(value: string): string {
  return finalizeAppSlug(value)
}

export function isValidAppSlug(value: string): boolean {
  if (value.length < 3 || value.length > 50) return false
  if (!/^[a-z][a-z0-9-]*$/.test(value)) return false
  if (value.includes('--')) return false
  if (value.endsWith('-')) return false
  return true
}
